<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
import "../src/assets/style/common.less"
import "../src/assets/style/iconfont.css"
import "../src/assets/style/github-markdown.css"


export default {
  name: 'app',
  components: {
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// App.vue?378fd302